const Contact = () => {
    return (
        <section className='page-section' id='contact'>
            <div className='container text-center' data-aos='fade-up'>
                <h2 className='section-heading text-uppercase'>Contatti</h2>

                <div className='row mt-5 justify-content-md-center'>
                    <div className='col col-md-8'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='info-box'>
                                    <i className='bi bi-pin-map-fill h4'></i>
                                    <h4>Dove siamo</h4>
                                    <a className='text-decoration-none' href='https://goo.gl/maps/APCGyxKmnrhCCVfL7'>
                                        Via Civitacampomarano 8, 00131, Roma, RM
                                    </a>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='info-box mt-4'>
                                    <i className='bi bi-envelope h4'></i>
                                    <h4>Email</h4>
                                    <a className='text-decoration-none' href='mailto:tecnico@marronesc.com'>
                                        tecnico@marronesc.com
                                    </a>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='info-box mt-4'>
                                    <i className='bi bi-telephone h4'></i>
                                    <h4>Chiamaci</h4>
                                    <a className='text-decoration-none' href='tel:+393334063036'>
                                        +39 3334063036
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default Contact;
